import React from "react"
import Card from "./Card"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
export default function Cards({ list, link, template, className, noName }) {
  // console.log(list)
  return !noName ? (
    <div className={"relative " + className}>
      <div className="px-2 lg:px-8  container mx-auto">
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-8">
          {list.map((li, key) => {
            return (
              <li key={key}>
                <Card
                  slug={link + li.slug.current}
                  image={template ? li.cardImage : li.image}
                  name={li.name}
                  template
                  capacity={li.capacity ? li.capacity : null}
                  lowPrice={li.lowPrice ? li.lowPrice : null}
                  highPrice={li.highPrice ? li.highPrice : null}
                />
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  ) : (
    <div className=" relative pt-12">
      <div className="px-2 lg:px-8 container mx-auto">
        <ul className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3  gap-4 lg:gap-8 ">
          {list.map((li, key) => {
            return (
              <li key={key}>
                <Link
                  to={link + li.slug.current}
                  className="shadow-sm hover:shadow-xl transition duration-300 ease-in-out"
                >
                  <GatsbyImage
                    image={
                      li.cardImage.asset && li.cardImage.asset.gatsbyImageData
                    }
                    className="w-full h-full"
                    alt={li.name}
                  />
                </Link>
              </li>
            )
          })}
        </ul>
      </div>
    </div>
  )
}
